// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import './common/font/font.css'
import 'element-ui/lib/theme-chalk/index.css';
/* 初始化css */
import 'normalize.css'

/* 引入全局组件 */
import components from '@/components/components'

/* 引入全局模板 */
import templates from '@/templates/templates'

/* 引入全局指令 */
import './directives/directives'

/* 引入 swiper */
import Swiper from 'swiper'
import 'swiper/css/swiper.css'

/* 引入 animate.css */
import 'animate.css/animate.css'

/* 引入 jquery */
import $ from 'jquery'

/* 引入 scrollreveal */
import scrollReveal from 'scrollreveal'

import VueMeta from 'vue-meta'

router.beforeEach((to, from, next) => {
  if (to.path != from.path) {
    window.scroll(0, 0) //  <= 这个
  }
  next()
})
Vue.use(components)
Vue.use(templates)
Vue.prototype.$Swiper = Swiper
Vue.prototype.$ = $
Vue.prototype.$scrollReveal = scrollReveal()
Vue.use(VueMeta)
Vue.use(ElementUI);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js